// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"2d0c131f","331":"aabd45c2","453":"4c84d9bc","510":"0c6fc409","854":"b37e88b8"}[chunkId] + ".chunk.js";
};